import React, { memo } from 'react';
import styles from '../../../styles/configuration/nlpconfiguration.module.scss';
import { InputBox, Selectbox, SwitchComponent } from '../../FormComponent';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@mui/material';

const SecuritySettings = memo(({ llmModelOptions, llmModelForValidation, strictMode, semanticFiltering, llmValidation, allowFileDownloads, allowFileUploads, allowedDomains, blockedDomains, handleInputChange }) => {
    return (
        <div className={styles.securitySettings}>
            <div className={styles.securityOptions}>
                <div className={styles.securitySettingsItem}>
                    <SwitchComponent size='small' checked={strictMode} onChange={(e) => handleInputChange(e, 'strictMode')} label="Strict Mode" description="Maximum security with strict validation"/>
                </div>
                <div className={styles.securitySettingsItem}>
                    <SwitchComponent size='small' checked={semanticFiltering} onChange={(e) => handleInputChange(e, 'semanticFiltering')} label="Semantic Filtering" description="Filter out sensitive or unwanted content"/>
                </div>
                <div className={styles.securitySettingsItem}>
                    <SwitchComponent size='small' checked={llmValidation} onChange={(e) => handleInputChange(e, 'llmValidation')} label="LLM Validation" description="Validate responses using language model checks"/>
                </div>
                <div className={styles.securitySettingsItem}>
                    <SwitchComponent size='small' checked={allowFileDownloads} onChange={(e) => handleInputChange(e, 'allowFileDownloads')} label="Allow File Downloads" description="Allow file downloads from the LLM"/>
                </div>
                <div className={styles.securitySettingsItem}>
                    <SwitchComponent size='small' checked={allowFileUploads} onChange={(e) => handleInputChange(e, 'allowFileUploads')} label="Allow File Uploads" description="Allow file uploads to the LLM"/>
                </div>
            </div>
            <div className={styles.securityOptions}>
                <div className={styles.securitySettingsItem}>
                    <span className={styles.label}>Allowed Domains</span>
                    <InputBox size='small' multiline rows={3} placeholder="Enter allowed domains separated by commas, e.g. example.com, test.com, staging.com" value={allowedDomains} onChange={(e) => handleInputChange(e, 'allowedDomains')}/>
                </div>
                <div className={styles.securitySettingsItem}>
                    <span className={styles.label}>Blocked Domains</span>
                    <InputBox size='small' multiline rows={3} placeholder="Enter blocked domains separated by commas, e.g. example.com, test.com, staging.com" value={blockedDomains} onChange={(e) => handleInputChange(e, 'blockedDomains')}/>
                </div>
            </div>
            {llmValidation && <div className={styles.securityOptions}>
                <div className={styles.securitySettingsItem}>
                    <span className={styles.label}>LLM Model For Validation</span>
                    <Selectbox size='small' placeholder="Select LLM Model" options={llmModelOptions} value={llmModelForValidation} onChange={(e) => handleInputChange(e, 'llmModelForValidation')} endIcon={
                        <Tooltip title="At present, only GPT-4o and GPT-4o mini models have support.">
                            <InformationCircleIcon className={'icon'} />
                        </Tooltip>
                    }/>
                </div>
            </div>}
        </div>
    );
});

SecuritySettings.displayName = 'SecuritySettings';

export default SecuritySettings;